import {Box, Flex} from "reflexbox";
import Input from "./Input";
import T from "i18n-react";
import {CSVLink} from "react-csv";
import IconButton from "./IconButton";
import _ from "lodash";
import CSSModules from 'helpers/CSSModulesUtil'
import Chip from "react-toolbox/lib/chip";
import React, {Component} from "react";


import Table from './Table'
import styles from './styles.scss'

import {filterTable, sortTable} from'./util'


const getCSVList = (source, tableHeadContent) => {
  let csvList = []

  const headers = _.map(tableHeadContent, header => header)
  csvList.push(headers)

  _.map(source, (row) => {
    const rowData = _.map(_.keys(tableHeadContent), (colKey) => ((row && row[colKey] ? _.toString(row[colKey]) : "")))
    csvList.push(rowData)
  })

  return csvList

}

const getFilteredSource = (source, tableSort, tableFilter) => {
  const filterAndSort = _.flowRight([(s) => sortTable(s, tableSort), (s) => filterTable(s, tableFilter)])
  return filterAndSort(source)

}


class TableV2 extends Component {

  render() {
    const {source, tableFilter, tableSort, tableHeadContent,  onInputChange, searchFilter, removeFilter, onRowClick, onMenuSubmit, selectable, csvFilename} = this.props

    const filteredSource = getFilteredSource(source, tableSort, tableFilter)
    const showingCount = filteredSource.length

    const csvList = getCSVList(filteredSource, tableHeadContent)

    return (
      <div>
        <Flex align='center'>
          <Input
            icon='search'
            hint={T.translate('containers.report.greenlight.table.input')}
            value={searchFilter}
            onChange={onInputChange}
          />
          <Flex
            auto
            justify='flex-end'
            align='center'
          >
            <CSVLink 
              key={`csv_link_${new Date().getTime()}`} 
              data={csvList}
              filename={csvFilename}
            >
              <IconButton
                icon='open_in_new'
                message={T.translate('pages.project.search.notification.csv_button')}
              />
            </CSVLink>
          </Flex>
        </Flex>
        <Flex align='center'>
          <Box auto>
            {
              _.flatten(_.map(tableFilter, (filters, colKey) => (
                _.map(filters, (filter) => (
                  <Chip key={ `chip_${colKey}_${filter}`} deletable onDeleteClick={() => {
                    removeFilter(filter, colKey)
                    this.forceUpdate()
                  }}>
                    <span>{filter}</span>
                  </Chip>
                ))
              )))
            }
          </Box>
          <Flex
            auto
            justify='flex-end'
            align='center'
          >
            <div styleName="sourceCountContainer">
              <span styleName="sourceCount">{`Showing ${showingCount} of ${source.length} results`}</span>
            </div>
          </Flex>
        </Flex>
        <Table
          key={new Date().getTime()}//force update
          selectable={selectable}
          source={source}
          onRowClick={onRowClick}
          onMenuSubmit={(data) => {
            onMenuSubmit(data)
            this.forceUpdate()
          }}
          tableFilter={tableFilter}
          tableSort={tableSort}
          tableHeadContent={tableHeadContent}
        />
      </div>
    )
  }
}



export default CSSModules(styles, TableV2)